/**
 * Design tokens for the questionnaire feature.
 * Single source of truth — import from here, never hard-code hex/hsl values.
 */
export const PALETTE_FOREST = 'hsl(var(--palette-forest, 176 72% 17%))';
export const PALETTE_AMBER  = 'hsl(var(--palette-amber,   33 100% 50%))';
export const PALETTE_CREAM  = 'hsl(var(--palette-cream,   40 100% 98%))';
export const PALETTE_MINT   = 'hsl(var(--palette-mint,   154  38% 94%))';
